import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

// Custom hook to detect when rehydration is complete
export default function useRehydrationComplete() {
  const [isRehydrated, setIsRehydrated] = useState(false);
  const isPersistorRehydrated = useSelector((state) => state._persist?.rehydrated);

  useEffect(() => {
    if (isPersistorRehydrated) {
      setIsRehydrated(true);
    }
  }, [isPersistorRehydrated]);

  return isRehydrated;
}
